<template>
  <ul class="swap-list">
    <li v-for="giftUpc in giftUpcs" :key="giftUpc.upcId" class="swap-list__item">
      <GWPRadioProductItem :id="`gift-product-${giftUpc.upcId}`" v-model="localModelValue" :value="giftUpc.upcId" name="gift-product-radio-item">
        <template #item="{ checked }">
          <GWPProductItem
            :title="giftUpc.name"
            :image="getImageUrl(giftProduct?.urlTemplate?.product, giftUpc.images[0]?.filePath)"
            :class="{ 'gwp-product-item--active': checked }"
            theme="light"
          >
            <template #title="{ title }">
              <h3 class="product-item-title body large">
                {{ title }}
              </h3>
            </template>
          </GWPProductItem>
        </template>
      </GWPRadioProductItem>
    </li>
  </ul>
</template>

<script setup lang="ts">
/* istanbul ignore file */
/* c8 ignore file */
import { computed } from 'vue';
import useGWPStore from '~/stores/useGWPStore';

import GWPProductItem from '../ProductItem.vue';
import GWPRadioProductItem from '~/components/common/form/CustomRadioInput.vue';

import { getImageUrl } from '../../utils';

const { promoId } = defineProps<{
  promoId: string;
}>();

const localModelValue = defineModel<number>({ required: true });

const store = useGWPStore();
const giftProduct = computed(() => store.getGiftProductByPromoId(promoId));
const giftUpcs = computed(() => giftProduct.value?.giftFormattedUpcs || []);
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.swap-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.swap-list__item {
  .product-item-title {
    @include truncate-multiline(2);
  }

  &:not(:first-child) {
    @include margin-top-s;
  }
  &:last-child {
    @include margin-bottom-xxs;
  }
}
</style>
